// src/firebase.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {

  apiKey: "AIzaSyAxjrtdn7kcIEMmzID9dq-_xu-t-vUl0Q8",

  authDomain: "lab-developers.firebaseapp.com",

  projectId: "lab-developers",

  storageBucket: "lab-developers.firebasestorage.app",

  messagingSenderId: "210203572137",

  appId: "1:210203572137:web:afca85ea7115731ae1b6b8"

};

const app = initializeApp(firebaseConfig);

const db = getFirestore(app);
const storage = getStorage(app);
const auth = getAuth(app);
const provider = new GoogleAuthProvider();

export { db, storage, auth, provider };
